var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCameraIconO(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 24,
    viewBox: "0 0 28 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28 6.00024V21.4288C28 22.8752 26.7969 24.0002 25.375 24.0002H2.625C1.14844 24.0002 0 22.8752 0 21.4288V6.00024C0 4.60739 1.14844 3.42882 2.625 3.42882H7.4375L8.09375 1.71453C8.47656 0.696673 9.46094 0.000244141 10.5547 0.000244141H17.3906C18.4844 0.000244141 19.4688 0.696673 19.8516 1.71453L20.5625 3.42882H25.375C26.7969 3.42882 28 4.60739 28 6.00024ZM20.5625 13.7145C20.5625 10.1788 17.6094 7.28596 14 7.28596C10.3359 7.28596 7.4375 10.1788 7.4375 13.7145C7.4375 17.3038 10.3359 20.1431 14 20.1431C17.6094 20.1431 20.5625 17.3038 20.5625 13.7145ZM18.8125 13.7145C18.8125 16.3395 16.625 18.4288 14 18.4288C11.3203 18.4288 9.1875 16.3395 9.1875 13.7145C9.1875 11.1431 11.3203 9.00024 14 9.00024C16.625 9.00024 18.8125 11.1431 18.8125 13.7145Z",
    fill: "#F38A00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCameraIconO);
export default __webpack_public_path__ + "static/media/camera-icon-o.526467e156e4e9325a9ae6ea72f6f234.svg";
export { ForwardRef as ReactComponent };